<template>
    <select class="form-control dropdown-bigger" @change="changeType($event.target.value)" v-bind:value="value"
            v-on:input="$emit('input', $event.target.value)">
        <option selected>Choose type</option>
        <option :key="type.id" :value="type.id" v-for="type in types">{{type.name}}</option>
    </select>
</template>
<script>
    export default {
        data() {
            return {
                // types: []
            }
        },
        props: ['value'],
        async mounted() {
            // this.types = await this.$store.getters.getTypes
            // this.$parent.typesLoaded = true
        },
        computed: {
            types(){
                return ((this.$store.getters.getTypes.length) ? this.$store.getters.getTypes : []);
            },
        },
        methods: {
            changeType(controlInterval) {
                let interval = ''
                this.types.forEach(function (element) {
                    if (element.id == controlInterval) {
                        interval = element.interval_control
                    }
                })

                this.$parent.form.interval_control = interval
            }
        }
    }
</script>
<style>
    .dropdown-bigger {
        padding: .75rem;
    }
</style>
